import { useState, useEffect } from 'react';

import UserApi from '../api/UserApi';

const useUserId = (defaultUserId?: number) => {
    const [userId, setUserId] = useState<number | undefined>(defaultUserId);

    useEffect(() => {
        UserApi.getUserId().then((user) => {
            setUserId(user as unknown as number);
        });
    }, []);

    return userId;
};

export default useUserId;
